<template>
  <span
    :class="['fs-14 zIndex9999 tr w100', textColor]"
    v-if="skipText?.length > 0"
    @click="handleSkipCTA"
    >{{ skipText }}
    <i :class="['hkfi-arrow-line fs-10 ml3 medium', textColor]"></i
  ></span>
</template>

<script>
import Utility from "../helpers/utility";
import { LoginStates } from "../helpers/loginStateConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_CLICK_LOGIN_SKIP,
  EVENT_SKIP_LOGIN,
} from "../helpers/analyticsEvents";
export default {
  name: "SkipLogin",
  components: {},
  props: {
    skipText: { required: false, default: "Skip" },
    textColor: { required: false, default: "color-white" },
    parentPage: { required: false, default: "number input" },
  },
  data() {
    return { modulePropsData: {} };
  },
  mounted() {
    // this.modulePropsData =
    //   typeof this.moduleProps != null &&
    //   typeof this.moduleProps != "null" &&
    //   typeof this.moduleProps != "undefined"
    //     ? JSON.parse(this.moduleProps)
    //     : {};
  },
  methods: {
    handleSkipCTA(e) {
      EVENT_CLICK_LOGIN_SKIP();
      EVENT_SKIP_LOGIN({ sectionName: "login - " + this.parentPage });
      LocalStorageFunc.setSessionStorageKey("LOGIN_FLOW_SKIP", true);
      Utility.isRedirectedFromUrl("/my-addresses") ||
      Utility.isRedirectedFromUrl("/save-address") ||
      !LocalStorageFunc.isLoggedIn()
        ? Utility.sendToHomepageScreen()
        : Utility.redirectToHomeOrRedirectUrl();
    },
  },
  computed: {},
};
</script>
